import UsersRepository from 'repositories/admin/UsersRepository';

const useUsers = () => ({
  loadUsers: UsersRepository.index,
});

export default useUsers;
